import React from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'primary' | 'accent';
}

export const GlassCard = ({ children, className = '', variant = 'default' }: GlassCardProps) => {
  const variantStyles = {
    default: 'border-border hover:border-primary/30',
    primary: 'border-primary/30 bg-primary/5',
    accent: 'border-accent/30 bg-accent/5',
  };

  return (
    <div 
      className={`
        relative backdrop-blur-xl bg-surface/40 border 
        rounded-2xl transition-all duration-300 ease-out
        hover:shadow-lg hover:shadow-primary/5
        ${variantStyles[variant]}
        ${className}
      `}
    >
      {/* Inner Glow Gradient */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/5 to-transparent pointer-events-none opacity-50" />
      
      <div className="relative z-10 p-6">
        {children}
      </div>
    </div>
  );
};
